import React, { useEffect, useState, useContext } from 'react'
import { Link } from 'react-router-dom'
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi'
import styled from 'styled-components'
import { BedethequeContext } from '../utils/context/bedetheque'
import HeaderPage from '../components/headerPage';
import { formatCouverturePath } from '../libs/apiController'
import '../utils/style/comics.css'

const HOME_COUNT_KEY = 'comics_home_count'


const StyledAccueilLink = styled(Link)`
    text-decoration: none;
    color: #000000;    
`

function Accueil() {
    const {lastentries, wishlist} = useContext(BedethequeContext);
    // Nombre de nouveautés affichées, ajustable et persistant (localStorage).
    const [count, setCount] = useState(() => {
        const saved = parseInt(localStorage.getItem(HOME_COUNT_KEY))
        return Number.isFinite(saved) ? saved : 12
    })

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    if (!lastentries || !wishlist) return;

    const maxLastEntries = Math.max(lastentries?.length || 0, 1)
    const nbOfLastEntries = lastentries?.length > 0 ? Math.min(count, maxLastEntries) : 0
    const nbOfWishList = wishlist?.length
    const lblTome = ' albums'

    const handleCount = (value) => {
        const clamped = Math.min(Math.max(value, 1), maxLastEntries)
        setCount(clamped)
        localStorage.setItem(HOME_COUNT_KEY, String(clamped))
    }

    // Texte droit interactif : nombre de nouveautés réglable via −/+ (masqué en mobile via le header)
    const rightControl = lastentries?.length > 1 ? (
        <span className="home-count-ctrl">
            <span className="home-count-btn" role="button" aria-disabled={count <= 1}
                onClick={() => handleCount(count - 1)}><FiChevronLeft /></span>
            <span className="home-count-val">{nbOfLastEntries + lblTome}</span>
            <span className="home-count-btn" role="button" aria-disabled={count >= maxLastEntries}
                onClick={() => handleCount(count + 1)}><FiChevronRight /></span>
        </span>
    ) : (nbOfLastEntries + lblTome)

    return (
        <>
        <HeaderPage leftText={'◕‿‿◕'} centerText={'Nouveautés'} rightText={rightControl}/>

            <article className="comic">
                { lastentries?.map((album, idx) => ( album && idx < nbOfLastEntries &&
                    <StyledAccueilLink to={`serie/${album.idserie}/#${album._id}`} key={`${album._id}-${idx}`}>
                        <div className="panelFaro text-petit-bold">
                            <img alt={album.titre} src={formatCouverturePath(album)}></img>
                            <p className="text top-left">{album.serie}</p>
                            <p className="text bottom-right">
                                {!album.tome ? (album.genre) : ('#'+album?.tome + ' ' + album.titre) }
                            </p>
                        </div>
                    </StyledAccueilLink>
                )
                )}
            </article>
            
            <HeaderPage leftText={''} centerText={'Wishlist'} rightText={nbOfWishList + lblTome}/>
            
            <article className="comic">
                { wishlist?.map((album, idx) => ( album &&
                    <StyledAccueilLink to={`wishlist#${album._id}`} key={`${album._id}-${idx}`}>
                        <div className="panelFaro text-petit-bold">
                            <img alt={album.titre} src={formatCouverturePath(album)}></img>
                            <p className="text top-left">{album.serie}</p>                            
                            <p className="text bottom-right">
                                {!album.tome ? (album.genre.toString()) : ('#'+album?.tome + ' ' + album.titre) }
                            </p>
                        </div>
                    </StyledAccueilLink>
                )
                )}
            </article>
        </>
    )
}
  
export default Accueil